// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api_proto/v1/review_generator.proto (package api_proto.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api_proto/v1/review_generator.proto.
 */
export const file_api_proto_v1_review_generator: GenFile = /*@__PURE__*/
  fileDesc("CiNhcGlfcHJvdG8vdjEvcmV2aWV3X2dlbmVyYXRvci5wcm90bxIMYXBpX3Byb3RvLnYxIiAKD1Jldmlld09yZGVyTGlzdBINCgVpdGVtcxgBIAMoCSLAAgoUUmV2aWV3UXVlc3Rpb25Db25maWcSRgoKdmlzaWJpbGl0eRgBIAMoCzIyLmFwaV9wcm90by52MS5SZXZpZXdRdWVzdGlvbkNvbmZpZy5WaXNpYmlsaXR5RW50cnkSPAoFb3JkZXIYAiADKAsyLS5hcGlfcHJvdG8udjEuUmV2aWV3UXVlc3Rpb25Db25maWcuT3JkZXJFbnRyeRIiChpwZXJtaXNzaW9uX3RvX3Bvc3RfdmlzaWJsZRgDIAEoCBoxCg9WaXNpYmlsaXR5RW50cnkSCwoDa2V5GAEgASgJEg0KBXZhbHVlGAIgASgIOgI4ARpLCgpPcmRlckVudHJ5EgsKA2tleRgBIAEoCRIsCgV2YWx1ZRgCIAEoCzIdLmFwaV9wcm90by52MS5SZXZpZXdPcmRlckxpc3Q6AjgBIiAKHkdldFJldmlld1F1ZXN0aW9uQ29uZmlnUmVxdWVzdCJVCh9HZXRSZXZpZXdRdWVzdGlvbkNvbmZpZ1Jlc3BvbnNlEjIKBmNvbmZpZxgBIAEoCzIiLmFwaV9wcm90by52MS5SZXZpZXdRdWVzdGlvbkNvbmZpZyJXCiFVcGRhdGVSZXZpZXdRdWVzdGlvbkNvbmZpZ1JlcXVlc3QSMgoGY29uZmlnGAEgASgLMiIuYXBpX3Byb3RvLnYxLlJldmlld1F1ZXN0aW9uQ29uZmlnIiQKIlVwZGF0ZVJldmlld1F1ZXN0aW9uQ29uZmlnUmVzcG9uc2UiGgoYR2V0UmV2aWV3U2V0dGluZ3NSZXF1ZXN0IlYKGUdldFJldmlld1NldHRpbmdzUmVzcG9uc2USDAoEc2x1ZxgBIAEoCRIXCg9nb29nbGVfcGxhY2VfaWQYAiABKAkSEgoKcmV2aWV3X3VybBgEIAEoCSI2ChtVcGRhdGVSZXZpZXdTZXR0aW5nc1JlcXVlc3QSFwoPZ29vZ2xlX3BsYWNlX2lkGAEgASgJIh4KHFVwZGF0ZVJldmlld1NldHRpbmdzUmVzcG9uc2UigwEKHExpc3RSZXZpZXdTdWJtaXNzaW9uc1JlcXVlc3QSDQoFbGltaXQYASABKAUSDgoGb2Zmc2V0GAIgASgFEh8KEm9ubHlfYWxsb3dfcHVibGlzaBgDIAEoCEgAiAEBEgwKBHNvcnQYBCABKAlCFQoTX29ubHlfYWxsb3dfcHVibGlzaCJjCh1MaXN0UmV2aWV3U3VibWlzc2lvbnNSZXNwb25zZRIzCgtzdWJtaXNzaW9ucxgBIAMoCzIeLmFwaV9wcm90by52MS5SZXZpZXdTdWJtaXNzaW9uEg0KBXRvdGFsGAIgASgDIvgBChBSZXZpZXdTdWJtaXNzaW9uEgoKAmlkGAEgASgJEh0KFWdlbmVyYXRlZF9yZXZpZXdfdGV4dBgCIAEoCRIaChJwZXJtaXNzaW9uX3RvX3Bvc3QYAyABKAgSFAoMZnJlZV9jb21tZW50GAQgASgJEhIKCndvcmtfdHlwZXMYBSADKAkSDwoHcmVhc29ucxgGIAMoCRITCgtpbXByZXNzaW9ucxgHIAMoCRIrCgdjcmVhdGVkGAggASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIUCgdkZWFsX2lkGAkgASgDSACIAQFCCgoIX2RlYWxfaWRCM1oxZ2l0aHViLmNvbS9oLXNjYXBlL2llc2FwdXJpL2dvL2FwaV9wcm90by92MTthcGl2MWIGcHJvdG8z", [file_google_protobuf_timestamp]);

/**
 * 質問項目の並び順（proto の map value に repeated を直接持てないための wrapper）
 *
 * @generated from message api_proto.v1.ReviewOrderList
 */
export type ReviewOrderList = Message<"api_proto.v1.ReviewOrderList"> & {
  /**
   * @generated from field: repeated string items = 1;
   */
  items: string[];
};

/**
 * Describes the message api_proto.v1.ReviewOrderList.
 * Use `create(ReviewOrderListSchema)` to create a new message.
 */
export const ReviewOrderListSchema: GenMessage<ReviewOrderList> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_review_generator, 0);

/**
 * 質問項目カスタマイズ設定（company 管理 / customer 表示で共通利用）
 *
 * @generated from message api_proto.v1.ReviewQuestionConfig
 */
export type ReviewQuestionConfig = Message<"api_proto.v1.ReviewQuestionConfig"> & {
  /**
   * 各選択肢の表示/非表示。key は "<section>:<option>" 形式（例 "workType:屋根修理"）
   *
   * @generated from field: map<string, bool> visibility = 1;
   */
  visibility: { [key: string]: boolean };

  /**
   * セクションごとの表示順。key は section（"workType" / "reason" / "impression"）
   *
   * @generated from field: map<string, api_proto.v1.ReviewOrderList> order = 2;
   */
  order: { [key: string]: ReviewOrderList };

  /**
   * HP掲載許可の質問自体の表示/非表示
   *
   * @generated from field: bool permission_to_post_visible = 3;
   */
  permissionToPostVisible: boolean;
};

/**
 * Describes the message api_proto.v1.ReviewQuestionConfig.
 * Use `create(ReviewQuestionConfigSchema)` to create a new message.
 */
export const ReviewQuestionConfigSchema: GenMessage<ReviewQuestionConfig> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_review_generator, 1);

/**
 * @generated from message api_proto.v1.GetReviewQuestionConfigRequest
 */
export type GetReviewQuestionConfigRequest = Message<"api_proto.v1.GetReviewQuestionConfigRequest"> & {
};

/**
 * Describes the message api_proto.v1.GetReviewQuestionConfigRequest.
 * Use `create(GetReviewQuestionConfigRequestSchema)` to create a new message.
 */
export const GetReviewQuestionConfigRequestSchema: GenMessage<GetReviewQuestionConfigRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_review_generator, 2);

/**
 * @generated from message api_proto.v1.GetReviewQuestionConfigResponse
 */
export type GetReviewQuestionConfigResponse = Message<"api_proto.v1.GetReviewQuestionConfigResponse"> & {
  /**
   * @generated from field: api_proto.v1.ReviewQuestionConfig config = 1;
   */
  config?: ReviewQuestionConfig;
};

/**
 * Describes the message api_proto.v1.GetReviewQuestionConfigResponse.
 * Use `create(GetReviewQuestionConfigResponseSchema)` to create a new message.
 */
export const GetReviewQuestionConfigResponseSchema: GenMessage<GetReviewQuestionConfigResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_review_generator, 3);

/**
 * @generated from message api_proto.v1.UpdateReviewQuestionConfigRequest
 */
export type UpdateReviewQuestionConfigRequest = Message<"api_proto.v1.UpdateReviewQuestionConfigRequest"> & {
  /**
   * @generated from field: api_proto.v1.ReviewQuestionConfig config = 1;
   */
  config?: ReviewQuestionConfig;
};

/**
 * Describes the message api_proto.v1.UpdateReviewQuestionConfigRequest.
 * Use `create(UpdateReviewQuestionConfigRequestSchema)` to create a new message.
 */
export const UpdateReviewQuestionConfigRequestSchema: GenMessage<UpdateReviewQuestionConfigRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_review_generator, 4);

/**
 * @generated from message api_proto.v1.UpdateReviewQuestionConfigResponse
 */
export type UpdateReviewQuestionConfigResponse = Message<"api_proto.v1.UpdateReviewQuestionConfigResponse"> & {
};

/**
 * Describes the message api_proto.v1.UpdateReviewQuestionConfigResponse.
 * Use `create(UpdateReviewQuestionConfigResponseSchema)` to create a new message.
 */
export const UpdateReviewQuestionConfigResponseSchema: GenMessage<UpdateReviewQuestionConfigResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_review_generator, 5);

/**
 * @generated from message api_proto.v1.GetReviewSettingsRequest
 */
export type GetReviewSettingsRequest = Message<"api_proto.v1.GetReviewSettingsRequest"> & {
};

/**
 * Describes the message api_proto.v1.GetReviewSettingsRequest.
 * Use `create(GetReviewSettingsRequestSchema)` to create a new message.
 */
export const GetReviewSettingsRequestSchema: GenMessage<GetReviewSettingsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_review_generator, 6);

/**
 * @generated from message api_proto.v1.GetReviewSettingsResponse
 */
export type GetReviewSettingsResponse = Message<"api_proto.v1.GetReviewSettingsResponse"> & {
  /**
   * 口コミURL用 slug（get-or-create で自動生成）
   *
   * @generated from field: string slug = 1;
   */
  slug: string;

  /**
   * Google Maps Place ID
   *
   * @generated from field: string google_place_id = 2;
   */
  googlePlaceId: string;

  /**
   * フロント表示用フル URL（slug 未設定なら空）
   *
   * @generated from field: string review_url = 4;
   */
  reviewUrl: string;
};

/**
 * Describes the message api_proto.v1.GetReviewSettingsResponse.
 * Use `create(GetReviewSettingsResponseSchema)` to create a new message.
 */
export const GetReviewSettingsResponseSchema: GenMessage<GetReviewSettingsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_review_generator, 7);

/**
 * @generated from message api_proto.v1.UpdateReviewSettingsRequest
 */
export type UpdateReviewSettingsRequest = Message<"api_proto.v1.UpdateReviewSettingsRequest"> & {
  /**
   * @generated from field: string google_place_id = 1;
   */
  googlePlaceId: string;
};

/**
 * Describes the message api_proto.v1.UpdateReviewSettingsRequest.
 * Use `create(UpdateReviewSettingsRequestSchema)` to create a new message.
 */
export const UpdateReviewSettingsRequestSchema: GenMessage<UpdateReviewSettingsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_review_generator, 8);

/**
 * @generated from message api_proto.v1.UpdateReviewSettingsResponse
 */
export type UpdateReviewSettingsResponse = Message<"api_proto.v1.UpdateReviewSettingsResponse"> & {
};

/**
 * Describes the message api_proto.v1.UpdateReviewSettingsResponse.
 * Use `create(UpdateReviewSettingsResponseSchema)` to create a new message.
 */
export const UpdateReviewSettingsResponseSchema: GenMessage<UpdateReviewSettingsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_review_generator, 9);

/**
 * @generated from message api_proto.v1.ListReviewSubmissionsRequest
 */
export type ListReviewSubmissionsRequest = Message<"api_proto.v1.ListReviewSubmissionsRequest"> & {
  /**
   * 取得件数（0 はデフォルト 20）
   *
   * @generated from field: int32 limit = 1;
   */
  limit: number;

  /**
   * @generated from field: int32 offset = 2;
   */
  offset: number;

  /**
   * true=HP掲載許可ありのみ
   *
   * @generated from field: optional bool only_allow_publish = 3;
   */
  onlyAllowPublish?: boolean;

  /**
   * "created_desc"（default） / "created_asc"
   *
   * @generated from field: string sort = 4;
   */
  sort: string;
};

/**
 * Describes the message api_proto.v1.ListReviewSubmissionsRequest.
 * Use `create(ListReviewSubmissionsRequestSchema)` to create a new message.
 */
export const ListReviewSubmissionsRequestSchema: GenMessage<ListReviewSubmissionsRequest> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_review_generator, 10);

/**
 * @generated from message api_proto.v1.ListReviewSubmissionsResponse
 */
export type ListReviewSubmissionsResponse = Message<"api_proto.v1.ListReviewSubmissionsResponse"> & {
  /**
   * @generated from field: repeated api_proto.v1.ReviewSubmission submissions = 1;
   */
  submissions: ReviewSubmission[];

  /**
   * 総件数（ページネーション用）
   *
   * @generated from field: int64 total = 2;
   */
  total: bigint;
};

/**
 * Describes the message api_proto.v1.ListReviewSubmissionsResponse.
 * Use `create(ListReviewSubmissionsResponseSchema)` to create a new message.
 */
export const ListReviewSubmissionsResponseSchema: GenMessage<ListReviewSubmissionsResponse> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_review_generator, 11);

/**
 * 投稿された口コミ案 1 件（屋根業者管理画面の履歴一覧用）
 *
 * @generated from message api_proto.v1.ReviewSubmission
 */
export type ReviewSubmission = Message<"api_proto.v1.ReviewSubmission"> & {
  /**
   * review_submissions.id（ULID）
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * LLM 生成口コミ案
   *
   * @generated from field: string generated_review_text = 2;
   */
  generatedReviewText: string;

  /**
   * HP掲載許可 はい=true / いいえ=false
   *
   * @generated from field: bool permission_to_post = 3;
   */
  permissionToPost: boolean;

  /**
   * 施主の自由記述
   *
   * @generated from field: string free_comment = 4;
   */
  freeComment: string;

  /**
   * 選択した工事内容
   *
   * @generated from field: repeated string work_types = 5;
   */
  workTypes: string[];

  /**
   * 選択した当社を選んだ理由
   *
   * @generated from field: repeated string reasons = 6;
   */
  reasons: string[];

  /**
   * 選択した印象点
   *
   * @generated from field: repeated string impressions = 7;
   */
  impressions: string[];

  /**
   * @generated from field: google.protobuf.Timestamp created = 8;
   */
  created?: Timestamp;

  /**
   * optional な案件紐付け
   *
   * @generated from field: optional int64 deal_id = 9;
   */
  dealId?: bigint;
};

/**
 * Describes the message api_proto.v1.ReviewSubmission.
 * Use `create(ReviewSubmissionSchema)` to create a new message.
 */
export const ReviewSubmissionSchema: GenMessage<ReviewSubmission> = /*@__PURE__*/
  messageDesc(file_api_proto_v1_review_generator, 12);

